import React from 'react';
import { SettingsProvider } from '../contexts/settingsContext';
import { CameraCapturesProvider } from '../contexts/cameraCapturesContext';

/**
 * UIProvider - Consolidates all UI-related context providers
 * Includes: settings, camera captures
 */
export function UIProvider({ children }) {
  return (
    <SettingsProvider>
      <CameraCapturesProvider>
        {children}
      </CameraCapturesProvider>
    </SettingsProvider>
  );
}
